import regexes from "shared/imports/regex"

/**
* This function parses a comma separated list of emails, and extracts any invalid addresses among them
* @name parseTestEmailInput
* @function
* @param {string} input - a comma separated string of emails
* @returns {object} - An object in the shape {hasValidAddresses: boolean, invalidAddresses: array}
*/
export const parseTestEmailInput = (input) => {
    const cleanInput = input.replace(regexes.removeEndCommaAndSpaces, "")
    const checkedArray = regexes.validateBcc.exec(cleanInput)

    const invalidAddresses = cleanInput
        .replace(/\s/g, "")
        .split(",")
        .filter(address => !regexes.emailValidationRegex.test(address))

    return {
        hasValidAddresses: (Boolean(checkedArray) && checkedArray[0] === cleanInput),
        invalidAddresses
    }
}

export const validateCc = (value) => {
    const escape = /,?([\s]+)?$/g
    const cleanString = value.replace(escape, "")
    const checkArray = regexes.validateBcc.exec(cleanString)

    // check values
    if (value === "") {
        return true
    }

    if (checkArray === null) {
        return false
    }

    if (checkArray[0] !== cleanString) {
        return false
    }

    return true
}
